import React from 'react';
import { useTranslation } from 'react-i18next';
import ProfileImage from '../../profileImage';

const ReceivedRequestsList = ({
  requests,
  onApprove,
  onReject,
  isProcessing
}) => {
  const { t } = useTranslation();

  if (requests.length === 0) {
    return (
      <div className="text-center py-12 bg-gray-50 rounded-lg">
        <div className="w-16 h-16 bg-gray-200 rounded-full flex items-center justify-center mx-auto mb-4">
          <svg className="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
          </svg>
        </div>
        <h4 className="text-lg font-medium text-gray-900 mb-2">{t('player.parents.noReceivedRequests')}</h4>
        <p className="text-gray-600">{t('player.parents.noReceivedRequestsDescription')}</p>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      {requests.map((request) => (
        <div key={request.requestId || request._id || request.id} className="bg-white border border-gray-200 rounded-lg p-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-4">
              <ProfileImage
                image={request.profilePicture}
                alt={request.userName}
                className="w-12 h-12 rounded-full object-cover"
              />
              <div>
                <h4 className="font-medium text-gray-900">
                  {request.userName}
                </h4>
                <p className="text-sm text-gray-600">
                  {t('player.parents.requestType')}: {request.requestType}
                </p>
                <p className="text-sm text-gray-600">
                  {t('player.parents.access')}: {Array.isArray(request.role) ? request.role.join(', ') : request.role}
                </p>
                <p className="text-xs text-gray-500">
                  {request.timeAgo || new Date(request.createdAt).toLocaleDateString()}
                </p>
              </div>
            </div>
            <div className="flex gap-2">
              <button
                onClick={() => onApprove(request.requestId || request._id || request.id)}
                disabled={isProcessing}
                className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 disabled:bg-gray-300 transition-colors text-sm"
              >
                {isProcessing ? t('common.loading') : t('player.parents.accept')}
              </button>
              <button
                onClick={() => onReject(request.requestId || request._id || request.id)}
                disabled={isProcessing}
                className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 disabled:bg-gray-300 transition-colors text-sm"
              >
                {isProcessing ? t('common.loading') : t('player.parents.reject')}
              </button>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ReceivedRequestsList; 